import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";

import './SequenceHolder.css';
import Modal from '../UI/Modals/Modal/Modal';
import { addBlock } from "../../actions/actions";
import { matchSequence } from '../../helpers';

class SequenceHolder extends Component {
    state = {
        modal: false,
        sequenceButtonsDisabled: this.props.sequenceButtonsDisabled
    };

    showSequence = blocks => { this.props.addBlock({ selectedBlocks: blocks, selectedId: blocks.id }) };

    toggleModal = () => { this.setState({ modal: !this.state.modal }, () => { this.props.deleteAllSequencesModal(this.state.modal) })};

    deleteSequence = deleteAll => {     // if deleteAll is true, all of the sequences will be deleted. Else, the first saved sequence will be deleted
        if (deleteAll) this.props.deleteAllSequence();
        else this.props.deleteOneSequence();
        this.toggleModal();
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) this.setState({ sequenceButtonsDisabled: this.props.sequenceButtonsDisabled })
    }

    render() {
        let sequences = [];
        for (let j = 1; j <= this.props.sequenceSaveLimit; j++) {
            let topicID = `${this.props.currentApp}-topic-${this.props.selectedTopicId}-${j}`;
            if (window.localStorage.getItem(topicID)) sequences.push(JSON.parse(window.localStorage.getItem(topicID)));
        }

        const selectedBlocks = [...this.props.selectedBlocks];
        const buttonsDisabled = this.state.sequenceButtonsDisabled;  // disabling the sequence holder buttons if a block is already playing else these buttons will start the sequence by stopping the currently playing block
        const clearButtonClass = `sequence-button ${buttonsDisabled ? 'button-disabled' : ''} ${sequences.length > 0 ? 'show-button' : 'hide-button'}`;
        const clearButton = (
            <div className={clearButtonClass} onClick={() => this.toggleModal(true)}>
                <i className="fa fa-times" />
            </div>
        );

        const sequenceHolderButtons = sequences.map((blocks, index) => {
            const matched = matchSequence([], blocks, selectedBlocks);  // if the selected sequence matches one of the already saved sequences, 'active-button' class will be activated
            const sequenceButtonClass = `sequence-button ${matched ? `active-button ${this.props.currentApp}` : ''} ${buttonsDisabled ? 'button-disabled' : ''}`;
            return (
                <div className={sequenceButtonClass} key={index} onClick={() => this.showSequence(blocks)}>
                    {index + 1}
                </div>
            )
        });

        const modal = (
            <Modal
                showModal={this.state.modal}
                hideModal={() => this.toggleModal(false)}
                hideCancelButton={false}
                modalBodyText='Are you sure you want to delete all of the sequences for this topic?'
                confirmationText='Yes'
                cancellationText='No'
                confirmed={() => this.deleteSequence(true)}
            />
        );

        return (
            <Fragment>
                {modal}
                <div className='sequence-holder'>
                    {clearButton}
                    {sequenceHolderButtons}
                </div>
            </Fragment>
        );
    }
}

SequenceHolder.propTypes = {
    sequences: PropTypes.array,
    onHandleSelectSequence: PropTypes.func,
};

const mapStateToProps = state => ({
    currentApp: state.appReducer.currentApp,
    showSequenceModal: state.touchPadReducer.showSequenceModal || false,
    selectedBlocks: state.touchPadReducer.selectedBlocks || [],
});

const mapDispatchToProps = dispatch => ({
    addBlock: params => dispatch(addBlock(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SequenceHolder);